<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="6" @click="toNewRouter('visitor-over-view')" v-if="permissionCodes.indexOf('007007000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('visitor-config')" v-if="permissionCodes.indexOf('007001000') !== -1">
        <i class="el-icon-damai-shenqing" style="font-size: 16px;"></i>
        <span slot="title">访客申请配置</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('visitor-device-manage')" v-if="permissionCodes.indexOf('007002000') !== -1">
        <i class="el-icon-damai-shebei1"></i>
        <span slot="title">访客机管理</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('visitor-register')" v-if="permissionCodes.indexOf('007003000') !== -1">
        <i class="el-icon-damai-dengji-"></i>
        <span slot="title">登记记录</span>
      </el-menu-item>
      <el-menu-item index="1" @click="toNewRouter('appointment-record')" v-if="permissionCodes.indexOf('007004000') !== -1">
        <i class="el-icon-damai-zhuanjiayuyue"></i>
        <span slot="title">预约记录</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('credit-card-record')" v-if="permissionCodes.indexOf('007005000') !== -1">
        <i class="el-icon-damai-shuaqia"></i>
        <span slot="title">出入记录</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('visitor-service-log')" v-if="permissionCodes.indexOf('007006000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
      <!--<el-menu-item index="3" @click="toNewRouter('housing-management')">-->
        <!--<i class="el-icon-damai-navicon-tjb"></i>-->
        <!--<span slot="title">访客统计</span>-->
      <!--</el-menu-item>-->
      <!--<el-menu-item index="4" @click="toNewRouter('permission-configuration')">-->
        <!--<i class="el-icon-damai-moban"></i>-->
        <!--<span slot="title">权限配置</span>-->
      <!--</el-menu-item>-->

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "appointment-record",
  2: "credit-card-record",
  3: "visitor-service-log",
  4: ["visitor-device-manage", "visitor-device-add", "visitor-device-modify"],
  5: "visitor-register",
  6: "visitor-over-view",
  7: ["visitor-config", "visitor-config-modify"],
});

export default {
  name: "visitor-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/VisitorNav.vue